import React, { memo, useState, useEffect, useCallback, useRef } from "react";
import styled from "styled-components";
import ReactPlayer from "react-player";

import mq from "./MediaQuery/MediaQuery";
import profile from "./assets/jun.png";
import programming from "./assets/programming.png";
import unico from "./assets/unico.jpg";
import github from "./assets/github.png";
import linkedIn from "./assets/linkedin.png";
import instagram from "./assets/instagram.png";
import contact from "./assets/contact.png";
import email from "./assets/mail.png";
import phone from "./assets/phone.png";
const Container = styled.div`
  width: 100%;
  height: 100vh;

  .header {
    display: flex;
    justify-content: center;
    position: fixed;
    height: 100px;
    width: 100%;
    z-index: 100;

    h1 {
      position: absolute;
      left: 0;
      color: white;
      font-size: 45px;
      margin-left: 130px;
      margin-top: 25px;

      ${mq.maxWidth("xxl")`
          display:none;
          `}
    }

    h3 {
      padding: 15px 30px;
      color: white;
      font-size: 20px;
      font-weight: 400;
      text-align: center;

      &:hover {
        cursor: pointer;
        color: #4bd19a;
      }

      ${mq.maxWidth("sm")`
           font-size: 15px;
           padding: 30px 10px;
          `}
    }
  }

  .firstPage {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 1100px;
    background: linear-gradient(-45deg, #151822, #161a29, #2f354d, #151822);
    background-repeat: no-repeat;
    background-size: 400% 400%;
    animation: background 15s ease-in-out infinite;
    overflow: hidden;

    ${mq.maxWidth("sm")`
           height: 900px
          `}

    @keyframes background {
      0% {
        background-position: 0 50%;
      }

      50% {
        background-position: 100% 50%;
      }

      100% {
        background-position: 0 50%;
      }
    }
    .content {
      .title {
        display: flex;
        h1 {
          color: white;
          font-size: 80px;
          margin-top: 370px;
          font-weight: 800;
          margin-left: -70px;

          ${mq.maxWidth("md")`
           font-size: 60px;
           margin-left: -10px;
          `}

          ${mq.maxWidth("sm")`
           font-size: 30px;
           margin-left: -15px;
           margin-top: 320px;
          `}
        }

        span {
          position: absolute;
          margin-left: 125px;
          margin-top: 370px;
          font-weight: 800;
          font-size: 80px;
          color: #04ff6e;
          animation-name: change;
          animation-duration: 3s;
          animation-timing-function: ease-in-out;
          animation-iteration-count: infinite;
          background-color: none;

          ${mq.maxWidth("md")`
           font-size: 60px;
           margin-left: 140px;
          `}

          ${mq.maxWidth("sm")`
           font-size: 30px;
           margin-left: 60px;
           margin-top: 320px;
          `}

          @keyframes change {
            0% {
              opacity: 0;
              transform: translateY(-30px);
            }
            50% {
              transform: translateY(2px);
              opacity: 1;
            }
            100% {
              transform: translateY(30px);
              opacity: 0;
            }
          }
        }
      }

      h2 {
        color: white;
        font-size: 30px;
        font-weight: 500;
        margin-left: 30px;

        ${mq.maxWidth("md")`
           margin-left: 0px;
          `}

        ${mq.maxWidth("sm")`
           font-size: 15px;
           margin-left: -10px;
          `}
      }
    }

    .scroll-downs {
      position: absolute;
      top: 650px;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;

      width: 34px;
      height: 55px;

      ${mq.maxWidth("sm")`
           top: 500px;
      `}

      .mousey {
        width: 10px;
        padding: 10px 15px;
        height: 45px;
        border: 5px solid #fff;
        border-radius: 25px;
        opacity: 0.75;
        box-sizing: content-box;
      }
      .scroller {
        margin-left: 2.5px;
        width: 3px;
        height: 10px;
        border: 1.5px solid #fff;
        border-radius: 25%;
        background-color: #fff;
        animation-name: scroll;
        animation-duration: 2.2s;
        animation-timing-function: cubic-bezier(0.15, 0.41, 0.69, 0.94);
        animation-iteration-count: infinite;
      }
      @keyframes scroll {
        0% {
          opacity: 0;
          transform: translateY(0px);
        }
        10% {
          transform: translateY(5px);
          opacity: 1;
        }
        100% {
          transform: translateY(30px);
          opacity: 0;
        }
      }
    }
  }

  .secondPage {
    background-color: #151822;
    height: 3000px;

    ${mq.maxWidth("sm")`
        height: 2100px;
    `}
    .section {
      background-color: #20222e;
      width: 100%;
      height: 220px;

      ${mq.maxWidth("sm")`
           height: 150px;
          `}

      .subTitle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 220px;
        margin: 0 130px;
        ${mq.maxWidth("lg")`
            margin: 0 80px;
        `}
        ${mq.maxWidth("md")`
            display: block;
            margin: 0 40px;
        `}
        h1 {
          color: white;
          font-size: 45px;
          ${mq.maxWidth("lg")`
            font-size: 40px;
        `}
          ${mq.maxWidth("md")`
             padding-top: 90px;
        `}
        }

        h2 {
          color: white;
          font-size: 18px;
          font-weight: 500;
          ${mq.maxWidth("lg")`
            font-size :15px;
        `}
        }
      }
    }

    .container1 {
      display: flex;
      justify-content: flex-end;
      margin-top: 200px;

      ${mq.maxWidth("sm")`
           margin-top: 0;
          `}

      .circle {
        height: 550px;
        width: 550px;
        background-color: #20222e;
        border-radius: 100%;
        ${mq.maxWidth("md")`
          margin:auto;
        `}

        ${mq.maxWidth("md")`
          display:none;
        `}
      }

      .box {
        width: 75%;
        height: 550px;
        background-color: #20222e;
        margin-left: -280px;

        ${mq.maxWidth("md")`
          width: 100%;
        `}

        ${mq.maxWidth("sm")`
           height: 600px;
          `}

        img {
          width: 450px;
          margin-left: -200px;
          margin-top: 50px;

          ${mq.maxWidth("xl")`
            width: 300px;
            margin-top: 120px;
        `}
          ${mq.maxWidth("md")`
            width: 200px;
            margin-left: 35px;
            margin-top: 30px;
        `}
        }

        .whoAmI {
          position: absolute;
          width: 650px;
          right: 200px;
          top: 1620px;

          ${mq.maxWidth("xxxl")`
            width: 450px;
        `}
          ${mq.maxWidth("xxl")`
            width: 400px;
        `}
         ${mq.maxWidth("xl")`
            right: 100px;
            width: 550px;
        `}
        ${mq.maxWidth("lg")`
            right: 100px;
            width: 340px;
        `}

          ${mq.maxWidth("md")`
            right: 30px;
            width: 300px;
            margin-top: 80px;
        `}

            ${mq.maxWidth("sm")`
            right: 20px;
            width: 250px;
            margin-top: -330px;
        `}
        
          h5 {
            color: #4bd19a;
            font-size: 23px;
            margin: 0 0 10px 0;
            text-align: right;
          }

          h4 {
            color: white;
            font-size: 45px;
            margin: 0;
            text-align: right;
          }

          p {
            color: #d2d3d5;
            font-size: 21px;
            text-align: right;
            font-weight: 300;

            ${mq.maxWidth("xxl")`
            font-size: 18px;
        `}
            ${mq.maxWidth("lg")`
            font-size: 16px;
        `}
            ${mq.maxWidth("md")`
            font-size: 14px;
        `}

            ${mq.maxWidth("sm")`
            font-size:12px
        `}
          }
        }
      }
    }

    .container2 {
      display: flex;
      margin-top: 250px;

      ${mq.maxWidth("sm")`
             margin-top: 150px;
        `}

      .box {
        width: 40%;
        height: 550px;
        background-color: #20222e;

        ${mq.maxWidth("xxxl")`
            width: 35%;
        `}

        ${mq.maxWidth("xxl")`
             width: 30%;
        `}
        ${mq.maxWidth("lg")`
             display:none
        `}

        img {
          width: 620px;
          z-index: 1;
          position: absolute;
          margin: -40px 0 0 180px;

          ${mq.maxWidth("xxxl")`
            margin-left: 50px;
        `}

          ${mq.maxWidth("xxl")`
            margin: 20px 0 0 50px;
            width: 500px;
        `}
          ${mq.maxWidth("lg")`
              display:none;
        `}
        }
      }
      .circle {
        height: 550px;
        width: 550px;
        background-color: #20222e;
        border-radius: 100%;
        margin-left: -260px;

        ${mq.maxWidth("lg")`
             display:none
        `}
      }

      .whatSkills {
        width: 500px;
        margin-left: 70px;
        ${mq.maxWidth("xxxl")`
            margin-left: 50px;
            width: 450px;
        `}

        ${mq.maxWidth("xxl")`
            width: 340px;
        `}

        ${mq.maxWidth("lg")`
             margin: auto;
             width: 600px;
        `}

        ${mq.maxWidth("md")`
             margin: auto;
             width: 500px;
        `}


        ${mq.maxWidth("sm")`
             margin: auto;
             width: 300px;
        `}


        h5 {
          color: #4bd19a;
          font-size: 23px;
          margin: 0 0 10px 0;
        }

        h4 {
          color: white;
          font-size: 45px;
          margin: 0;
          margin-bottom: 20px;
        }

        .subject {
          display: flex;
          justify-content: space-between;

          h6 {
            color: #d2d3d5;
            font-size: 18px;
            font-weight: 400;
            margin-top: 30px;
            margin-bottom: 15px;

            ${mq.maxWidth("sm")`
             font-size: 15px;
          `}
          }

          h5 {
            color: #d2d3d5;
            font-size: 17px;
            font-weight: 300;
            margin-top: 30px;
            margin-bottom: 15px;

            ${mq.maxWidth("sm")`
             font-size: 13px;
          `}
          }
        }

        .htmlCss {
          width: 90%;
          height: 5px;
          background-color: #4bd19a;
        }

        .javascript {
          width: 80%;
          height: 5px;
          background-color: #4bd19a;
        }

        .react {
          width: 90%;
          height: 5px;
          background-color: #4bd19a;
        }

        .nodejs {
          width: 70%;
          height: 5px;
          background-color: #4bd19a;
        }

        .mysql {
          width: 70%;
          height: 5px;
          background-color: #4bd19a;
        }

        .adobe {
          width: 90%;
          height: 5px;
          background-color: #4bd19a;
        }
      }
    }

    .container3 {
      display: flex;
      margin-top: 250px;
      justify-content: center;

      ${mq.maxWidth("sm")`
             margin-top: 150px;
        `}

      .box {
        width: 50%;
        height: 550px;
        background-color: #20222e;
        z-index: 2;

        ${mq.maxWidth("md")`
          width: 600px;
          height: 600px;
          border-radius: 100%;
        `}

        ${mq.maxWidth("sm")`
          width: 380px;
          height: 380px;
        `}
        

        h4 {
          color: #4bd19a;
          font-size: 45px;
          width: 100%;
          text-align: center;
          z-index: 1;
          margin: 80px 0 90px 0;

          ${mq.maxWidth("lg")`
            font-size: 35px;
            margin: 80px 0 70px 0;
        `}

          ${mq.maxWidth("md")`
          font-size: 30px;
          margin: 130px 0 70px 0;
        `}
         ${mq.maxWidth("sm")`
           font-size: 20px;
          margin: 75px 0 40px 0;
        `}
        }

        h5 {
          color: white;
          font-weight: 500;
          font-size: 20px;
          text-align: center;
          margin-bottom: 20px;

          ${mq.maxWidth("lg")`
            font-size: 18px;
        `}
          ${mq.maxWidth("md")`
          font-size: 16px;
        `}
               ${mq.maxWidth("sm")`
           font-size: 12px;
           padding: 0 45px;
        `}
        }

        h6 {
          color: #d2d3d5;
          font-weight: 200;
          font-size: 17px;
          text-align: center;
          margin-top: 0;
          margin-bottom: 80px;
          ${mq.maxWidth("lg")`
            font-size: 15px;
        `}
          ${mq.maxWidth("md")`
          font-size: 12px;
          margin-bottom: 40px;
        `}
        }
      }
      .circle1 {
        height: 550px;
        width: 550px;
        background-color: #20222e;
        border-radius: 100%;
        margin-right: -260px;

        ${mq.maxWidth("md")`
          display:none
        `}
      }
      .circle2 {
        height: 550px;
        width: 550px;
        background-color: #20222e;
        border-radius: 100%;
        margin-left: -260px;
        ${mq.maxWidth("md")`
          display:none
        `}
      }
    }
  }

  .thirdPage {
    background-color: #151822;
    height: 4500px;

    ${mq.maxWidth("xxxl")`
        height: 4000px;
    `}

    ${mq.maxWidth("xxl")`
        height: 3600px;
    `}

    ${mq.maxWidth("xl")`
        height: 3300px;
    `}

${mq.maxWidth("lg")`
        height: 3000px;
    `}


${mq.maxWidth("mlg")`
        height: 2800px;
    `}

${mq.maxWidth("md")`
        height: 2400px;
    `}

    ${mq.maxWidth("sm")`
        height: 2000px;
    `}
    .section {
      background-color: #20222e;
      width: 100%;
      height: 220px;

      .subTitle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 220px;
        margin: 0 130px;
        ${mq.maxWidth("lg")`
            margin: 0 80px;
        `}
        ${mq.maxWidth("md")`
            display: block;
            margin: 0 40px;
        `}
        h1 {
          color: white;
          font-size: 45px;
          ${mq.maxWidth("lg")`
            font-size: 40px;
        `}
          ${mq.maxWidth("md")`
             padding-top: 90px;
        `}
        }

        h2 {
          color: white;
          font-size: 18px;
          font-weight: 500;
          ${mq.maxWidth("lg")`
            font-size :15px;
        `}
        }
      }
    }

    .project {
      margin-top: 200px;
      margin-bottom: 80px;
      width: 850px;
      right: 200px;
      margin-left: 10%;

      ${mq.maxWidth("lg")`
            right: 100px;
            width: 600px;
        `}

      ${mq.maxWidth("md")`
            width: 500px;
            margin-top: 80px;
        `}

            ${mq.maxWidth("sm")`
            right: 20px;
            width: 300px;
            margin-bottom: 50px;
        `}
        
          h5 {
        color: #4bd19a;
        font-size: 23px;
        margin: 0 0 10px 0;
      }

      h4 {
        color: white;
        font-size: 45px;
        margin: 0;
      }

      h6 {
        color: #4bd19a;
        text-decoration: underline;
        font-size: 21px;

        &:hover {
          cursor: pointer;
        }

        ${mq.maxWidth("xxl")`
            font-size: 18px;
        `}
        ${mq.maxWidth("lg")`
            font-size: 16px;
        `}
            ${mq.maxWidth("md")`
            font-size: 14px;
        `}

            ${mq.maxWidth("sm")`
            font-size:12px
        `}
      }

      p {
        color: #d2d3d5;
        font-size: 21px;

        font-weight: 300;

        ${mq.maxWidth("xxl")`
            font-size: 18px;
        `}
        ${mq.maxWidth("lg")`
            font-size: 16px;
        `}
            ${mq.maxWidth("md")`
            font-size: 14px;
        `}

            ${mq.maxWidth("sm")`
            font-size:12px
        `}
      }
    }

    .videoImgBox {
      width: 80%;
      border-radius: 10%;
      margin: auto;

      img {
        width: 100%;
        margin-top: 80px;

        ${mq.maxWidth("sm")`
            margin-top: 50px;
        `}
      }
    }
  }

  .forthPage {
    background-color: #151822;
    height: 1450px;

    ${mq.maxWidth("md")`
         height: 1150px;
    `}

    ${mq.maxWidth("sm")`
        height: 1150px;
    `}

    .section {
      background-color: #20222e;
      width: 100%;
      height: 220px;

      .subTitle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 220px;
        margin: 0 130px;
        ${mq.maxWidth("lg")`
            margin: 0 80px;
        `}
        ${mq.maxWidth("md")`
            display: block;
            margin: 0 40px;
        `}
        h1 {
          color: white;
          font-size: 45px;
          ${mq.maxWidth("lg")`
            font-size: 40px;
        `}
          ${mq.maxWidth("md")`
             padding-top: 90px;
        `}
        }

        h2 {
          color: white;
          font-size: 18px;
          font-weight: 500;
          ${mq.maxWidth("lg")`
            font-size :15px;
        `}
        }
      }
    }

    .flexBox {
      display: flex;
      justify-content: space-between;
      margin-top: 200px;
      ${mq.maxWidth("md")`
            margin-top: 80px;
        `}

      .picture {
        width: 50%;
        display: flex;

        ${mq.maxWidth("md")`
                display:none;
            `}

        .square {
          width: 70%;
          height: 550px;
          background-color: #20222e;

          ${mq.maxWidth("xl")`
                   width: 50%;
      `}

          img {
            width: 650px;
            z-index: 1;
            position: absolute;
            margin-left: 7%;

            ${mq.maxWidth("xxl")`
              width: 550px;
              margin-left: 0;
            `}
            ${mq.maxWidth("xl")`
                  margin-top: 100px;
                   width: 450px;
            `}
          }
        }

        .circle {
          height: 550px;
          width: 550px;
          background-color: #20222e;
          border-radius: 100%;
          margin-left: -300px;
          margin-top: 100px;
        }
      }

      .content {
        width: 40%;
        margin-top: 100px;

        ${mq.maxWidth("md")`
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;            
        `}

        h5 {
          color: #4bd19a;
          font-size: 23px;
          margin: 0 0 10px 0;
        }

        h4 {
          color: white;
          font-size: 45px;
          margin: 0;
        }

        .phoneMail {
          display: flex;
          flex-direction: column;

          .phone {
            width: 450px;
            height: 70px;
            background-color: #20222e;
            border-radius: 100px;
            margin-top: 50px;
            display: flex;
            justify-content: space-between;

            ${mq.maxWidth("xxl")`
              width: 350px;
      `}

            ${mq.maxWidth("lg")`
                  width: 280px;
        `}

        ${mq.maxWidth("md")`
                width: 450px;
            `}  


        ${mq.maxWidth("sm")`
                  width: 340px;
            `}  

            img {
              width: 50px;
              height: 50px;
              margin: 10px 0 0 15px;
            }

            h6 {
              width: 100%;
              text-align: center;
              color: #d2d3d5;
              font-size: 18px;
              font-weight: 400;
              margin: 25px 0px 0 0;

              ${mq.maxWidth("lg")`
            font-size: 16px;
        `}
            }
          }

          .mail {
            width: 450px;
            height: 70px;
            background-color: #20222e;
            border-radius: 100px;
            margin-top: 50px;
            display: flex;
            justify-content: space-between;

            ${mq.maxWidth("xxl")`
              width: 350px;
      `}

            ${mq.maxWidth("lg")`
                  width: 280px;
        `}

            ${mq.maxWidth("md")`
                width: 450px;
            `}  

            ${mq.maxWidth("sm")`
                width: 340px;
            `}  


            img {
              width: 50px;
              height: 50px;
              margin: 10px 0 0 15px;
            }

            h6 {
              width: 100%;
              text-align: center;
              color: #d2d3d5;
              font-size: 18px;
              font-weight: 400;
              margin: 25px 0px 0 0;

              ${mq.maxWidth("lg")`
            font-size: 16px;
        `}
            }
          }
        }
      }
    }

    .footer {
      display: flex;
      justify-content: space-between;
      align-items: end;
      margin: 200px 40px 0 40px;

      ${mq.maxWidth("sm")`
          margin: 250px 25px 0 25px;
    `}

      .copyright {
        h6 {
          font-size: 15px;
          color: #d2d3d5;
          font-weight: 600;

          ${mq.maxWidth("sm")`
           font-size: 12px;
           margin-bottom: 18px;
          `}
        }
      }

      .contactFlex {
        display: flex;
        flex-direction: column;
        align-items: end;

        .logos {
          img {
            width: 30px;
            margin-bottom: 25px;
            border: 12px solid #20222e;
            border-radius: 100%;
            margin-left: 9px;

            ${mq.maxWidth("sm")`
            width: 20px;
            margin-bottom: 15px;
          `}

            &:hover {
              cursor: pointer;
              opacity: 50%;
            }
          }
        }

        h6 {
          font-size: 15px;
          color: #d2d3d5;
          font-weight: 600;
          text-align: end;
          margin: 0 0 25px 0;

          ${mq.maxWidth("sm")`
           font-size: 12px;
           margin: 0 0 15px 0;
          `}
        }
      }
    }
  }
`;

const App = memo(() => {
  // 메인페이지 타이틀 상태값
  const [text, setText] = useState("Web Developer");

  // 섹션을 강조할 값
  const [forSection, setForSection] = useState("");

  // 스크롤 위치별 폰트굵기 상태값
  const [homeBold, setHomeBold] = useState("400");
  const [aboutBold, setAboutBold] = useState("400");
  const [portfolioBold, setPortfolioBold] = useState("400");
  const [contactBold, setContactBold] = useState("400");

  const [navigationColor, setNavigationColor] = useState(null);

  /** 참조변수  */
  // Home 페이지
  const homeRef = useRef(null);
  // About 페이지
  const aboutRef = useRef(null);
  // PortFolio 페이지
  const portfolioRef = useRef(null);
  // Contact 페이지
  const contactRef = useRef(null);

  /** 렌더링 시 실행 */
  useEffect(() => {
    const interval = setInterval(() => {
      setText((text) =>
        text === "Web Developer" ? "Web Designer" : "Web Developer"
      );
    }, 3000); // 3초마다 자동으로 텍스트 내용 바꾸기

    return () => {
      clearInterval(interval);
    };
  }, []);

  /** 스크롤 이벤트를 위한 useEffect */
  useEffect(() => {
    /** 스크롤 이벤트 */
    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      /** 스크롤 별 폰트 굵기 변경 */
      // 스크롤 위치별 해당하는 폰트 굵기만 굵게하고 그외에는 400 고정
      if (scrollPosition >= contactRef.current.offsetTop) {
        setAboutBold("400");
        setHomeBold("400");
        setPortfolioBold("400");
        setContactBold("700");
      } else if (scrollPosition >= portfolioRef.current.offsetTop) {
        setAboutBold("400");
        setHomeBold("400");
        setPortfolioBold("700");
        setContactBold("400");
      } else if (scrollPosition >= aboutRef.current.offsetTop) {
        setHomeBold("400");
        setAboutBold("700");
        setPortfolioBold("400");
        setContactBold("400");
      } else if (scrollPosition >= homeRef.current.offsetTop) {
        setHomeBold("700");
        setAboutBold("400");
        setPortfolioBold("400");
        setContactBold("400");
      } else {
        setHomeBold("400");
        setAboutBold("400");
        setPortfolioBold("400");
        setContactBold("400");
      }
      /** 스크롤 별 섹션 강조부분 넣기 */
      // 스크롤 위치별 강조 섹션 넣고 해당하지 않을 경우 빈값
      if (scrollPosition >= contactRef.current.offsetTop + 50) {
        setForSection("Contact");
      } else if (scrollPosition >= portfolioRef.current.offsetTop + 50) {
        setForSection("Portfolio");
      } else if (scrollPosition >= aboutRef.current.offsetTop + 50) {
        setForSection("About Me");
      } else {
        setForSection("");
      }

      /** 스크롤네비에이션 색상 변경 */
      // about위치 + 일정 수보다 높을 경우 네비게이션 배경색 생기기
      if (scrollPosition >= aboutRef.current.offsetTop + 50) {
        setNavigationColor("#161822");
        // setNavigationColor("#20222E");
      } else {
        setNavigationColor(null);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  /** 네비게이션 클릭시 강제이동 함수 */
  // 섹션을 가리고 컨텐츠만 보여주기위해 위치에 + 130을 더함
  const moveTo = useCallback((ref) => {
    window.scrollTo({
      top: ref.current.offsetTop + 130,
      behavior: "smooth",
    });
  }, []);

  // moveTo함수는 130위치를 더해서 홈을 이동시에는 정확한 맨 위쪽을 보여줘야하므로 새로운 함수 생성
  const moveToHome = useCallback((e) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <Container>
      <div className="header" style={{ backgroundColor: navigationColor }}>
        <h1>{forSection}</h1>
        <h3 onClick={moveToHome} style={{ fontWeight: homeBold }}>
          Home
        </h3>
        <h3
          onClick={() => {
            moveTo(aboutRef);
          }}
          style={{ fontWeight: aboutBold }}
        >
          About
        </h3>
        <h3
          onClick={() => {
            moveTo(portfolioRef);
          }}
          style={{ fontWeight: portfolioBold }}
        >
          Portfolio
        </h3>
        <h3
          onClick={() => {
            moveTo(contactRef);
          }}
          style={{ fontWeight: contactBold }}
        >
          Contact
        </h3>
      </div>
      <div className="firstPage" ref={homeRef}>
        <div className="content">
          <div className="title">
            <h1>I'm a</h1>
            <span
              style={{ color: text === "Web Designer" ? "#FF745F" : "#04ff6e" }}
            >
              {text}
            </span>
          </div>
          <h2>Aiming to be a skilled Full Stack Developer</h2>
        </div>
        <div className="scroll-downs">
          <div className="mousey">
            <div className="scroller"></div>
          </div>
        </div>
      </div>
      <div ref={aboutRef} className="secondPage">
        <div className="section">
          <div className="subTitle">
            <h1>About Me</h1>
            {/* <h2>Discover More About Me</h2> */}
          </div>
        </div>
        <div className="container1">
          <div className="circle"></div>
          <div className="box">
            <img src={profile} alt="profile" />
            <div className="whoAmI">
              <h5>Self-introduction</h5>
              <h4>Who am I?</h4>
              <p>
                My name is Junbeom Woo and I am 26 years old. I have a bright
                and outgoing personality and I am passionate about Web
                development. <br />  I hold a residence permit under the EU regulations.
                <br />
                <br />
                I obtained a Bachelor’s degree in Visual Design in South Korea
                and continued my studies in a 6-month long Full-Stack coding
                boot camp focused on foundational knowledge in Web development.
                <br />
                <br />I have moved to Denmark in late March 2024 and I am
                currently seeking employment in Copenhagen.
              </p>
            </div>
          </div>
        </div>
        <div className="container2">
          <div className="box">
            <img src={programming} alt="iamge" />
          </div>
          <div className="circle"></div>
          <div className="whatSkills">
            <h5>Skills</h5>
            <h4>What skills do I have?</h4>

            <div className="subject">
              <h6>HTML & CSS</h6>
              <h5>90</h5>
            </div>
            <div className="htmlCss" />

            <div className="subject">
              <h6>JAVASCRIPT & TYPESCRIPT</h6>
              <h5>80</h5>
            </div>
            <div className="javascript" />

            <div className="subject">
              <h6>REACT & NEXT.JS</h6>
              <h5>90</h5>
            </div>
            <div className="react" />

            <div className="subject">
              <h6>NODE.JS & EXPRESS</h6>
              <h5>70</h5>
            </div>
            <div className="nodejs" />

            <div className="subject">
              <h6>MySQL</h6>
              <h5>70</h5>
            </div>
            <div className="mysql" />

            <div className="subject">
              <h6>Adobe Illustrator & Photoshop</h6>
              <h5>90</h5>
            </div>
            <div className="adobe" />
          </div>
        </div>
        <div className="container3">
          <div className="circle1"></div>
          <div className="box">
            <h4>Academic Credentials</h4>
            <h5>
              Ezen Academy, Full Stack(JavaScript) Web Developer (Front End &
              Back End)
            </h5>
            <h6>August 2022 - January - 2023 (920hr / 115days)</h6>
            <h5>Bachelor of Visual Design, Jangan University, South Korea</h5>
            <h6>March 2016 - February 2022</h6>
          </div>
          <div className="circle2"></div>
        </div>
      </div>
      <div ref={portfolioRef} className="thirdPage">
        <div className="section">
          <div className="subTitle">
            <h1>Portfolio</h1>
          </div>
        </div>
        <div className="project">
          <h5>Web Shopping mall</h5>
          <h4>UNICO</h4>
          <p>
            I have created a virtual brand named 'UNICO' specializing in selling
            sunglasses and eyeglasses.
            <br />
            <br />
            It is a responsive website with a backend server for smooth
            communication between clients and data.
            <br />
            <br />
            Additionally, I implemented efficient data processing and retrieval
            in dynamic web applications using MySQL.
          </p>
          <h6
            onClick={() => {
              window.open(
                "http://ec2-3-73-1-218.eu-central-1.compute.amazonaws.com:3001/",
                "_blank"
              );
            }}
          >
            Visit the website here
          </h6>
        </div>
        <div className="videoImgBox">
          <ReactPlayer
            url={"/unico.mp4"}
            width="100%"
            height="auto"
            loop={true}
            playing={true}
            muted={true}
            controls={true}
            alt="Main Video copyright GENTLEMONSTER"
          />
          <img src={unico} alt="WebSite" />
        </div>
        <div className="project">
          <h5>Movie Chart Site</h5>
          <h4>NMP</h4>
          <p>
            I developed a movie chart site named “NMP” that showcases popular
            recent movies as part of a mini-project.
            <br />
            <br />
            I used Next.js and TypeScript, and it is deployed on Vercel.
          </p>
          <h6
            onClick={() => {
              window.open("https://nmp-mini-project.vercel.app/");
            }}
          >
            Visit the website here
          </h6>
        </div>
        <div className="videoImgBox">
          <ReactPlayer
            url={"/nmp.mp4"}
            width="100%"
            height="auto"
            loop={true}
            playing={true}
            muted={true}
            controls={true}
            alt="Main Video copyright GENTLEMONSTER"
          />
        </div>
      </div>
      <div ref={contactRef} className="forthPage">
        <div className="section">
          <div className="subTitle">
            <h1>Contact</h1>
          </div>
        </div>
        <div className="flexBox">
          <div className="picture">
            <div className="square">
              <img src={contact} alt="contact" />
            </div>
            <div className="circle"></div>
          </div>
          <div className="content">
            <h5>Contact Me</h5>
            <h4>Get in touch</h4>
            <div className="phoneMail">
              <div className="phone">
                <img src={phone} alt="phone" />
                <h6>+45 44 11 14 18</h6>
              </div>
              <div className="mail">
                <img src={email} alt="email" />
                <h6>junbeom2.woo@gamil.com</h6>
              </div>
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="copyright">
            <h6>@2024 Junbeom Woo</h6>
          </div>
          <div className="contact">
            <div className="contactFlex">
              <div className="logos">
                <img
                  src={github}
                  alt={github}
                  onClick={() => {
                    window.open("https://github.com/junbeomwooo", "_blank");
                  }}
                />
                <img
                  src={linkedIn}
                  alt={linkedIn}
                  onClick={() => {
                    window.open(
                      "https://www.linkedin.com/in/woojunbeom/",
                      "_blank"
                    );
                  }}
                />
                <img
                  src={instagram}
                  alt="instagram"
                  onClick={() => {
                    window.open(
                      "https://www.instagram.com/wwjjjbbb/",
                      "_blank"
                    );
                  }}
                />
              </div>
              <h6>junbeom2.woo@gmail.com</h6>
              <h6>+45 44 11 14 18</h6>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
});

export default App;
